import Vue from 'vue'
import loginMixin from './loginMixin'
import permissionsMixin from './permissionsMixin'
import preloadDataMixin from './preloadDataMixin'
import pageStructureMixin from './pageStructureMixin'
import alertMessageMixin from './alertMessageMixin'
import routeMixin from './routeMixin'

Vue.mixin(loginMixin)
Vue.mixin(permissionsMixin)
Vue.mixin(preloadDataMixin)
Vue.mixin(pageStructureMixin)
Vue.mixin(alertMessageMixin)
Vue.mixin(routeMixin)